import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Members from './components/Members';
import NewMember from './components/NewMember';
import Attendance from './components/Attendance';
import Birthday from './components/Birhtday';
import Finance from './components/Finance';
import AddFinancialTransaction from './components/AddFinancialTransaction';
import TransactionRecords from './components/TransactionRecords';
import TitheTracking from './components/TitheTracking';
import Equipments from './components/Equipments';
import WelfareTracking from './components/Welfare';
import EquipmentInventory from './components/EquipmentInventory';
import AddEquipment from './components/AddEquipment';
import SMSBroadcast from './components/SMSBroadcast';
import ScheduledSMS from './components/ScheduledSMS';
import ComposeSMS from './components/ComposeSMS';
import Visitor from './components/Visitor';
import AddVisitor from './components/AddVisitor';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Students from './components/Students';
import StudentInterest from './components/StudentInterest';
import VisitorExtra from './components/VisitorExtra';
import Reports from './components/Reports';
import Users from './components/Users';
import Settings from './components/Settings';
import Logout from './components/Logout';
import FirstTimer from './components/FirstTimer';
import ScripturePromises from './components/ScripturePromises';
import Inspiration from './components/Inspiration';
import Test from './components/AnimatedScroll';
import AnimatedScroll from './components/AnimatedScroll';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/member"
          element={
            <ProtectedRoute>
              <Members />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newmember"
          element={
            <ProtectedRoute>
              <NewMember />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Attendance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/birthday"
          element={
            <ProtectedRoute>
              <Birthday />
            </ProtectedRoute>
          }
        />
        <Route
          path="/finance"
          element={
            <ProtectedRoute>
              <Finance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addfinancialtransaction"
          element={
            <ProtectedRoute>
              <AddFinancialTransaction />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactionrecords"
          element={
            <ProtectedRoute>
              <TransactionRecords />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tithetracking"
          element={
            <ProtectedRoute>
              <TitheTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/equipments"
          element={
            <ProtectedRoute>
              <Equipments />
            </ProtectedRoute>
          }
        />
        <Route
          path="/equipments/:id"
          element={
            <ProtectedRoute>
              <div>Equipment Details</div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/welfare"
          element={
            <ProtectedRoute>
              <WelfareTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/equipmentinventory"
          element={
            <ProtectedRoute>
              <EquipmentInventory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addequipment"
          element={
            <ProtectedRoute>
              <AddEquipment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/smsbroadcast"
          element={
            <ProtectedRoute>
              <SMSBroadcast />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scheduled-sms"
          element={
            <ProtectedRoute>
              <ScheduledSMS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/composesms"
          element={
            <ProtectedRoute>
              <ComposeSMS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/composesms/:id"
          element={
            <ProtectedRoute>
              <ComposeSMS />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Guests"
          element={
            <ProtectedRoute>
              <Visitor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-guest"
          element={
            <ProtectedRoute>
              <AddVisitor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students"
          element={
            <ProtectedRoute>
              <Students />
            </ProtectedRoute>
          }
        />
        <Route path="/studentInterest" element={<StudentInterest />} />
        {/* <Route path="/guestsRegistration" element={<FirstTimer />} /> */}
        <Route path="/guestsRegistration" element={<VisitorExtra />} />
        <Route path="/inspiration" element={<Inspiration />} />
        <Route path="/scripture-promises" element={<ScripturePromises />} />
        {/* <Route
          path="/scripture-promises"
          element={
            <ProtectedRoute>
              <ScripturePromises />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
